// @flow

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { getLang } from '../../../i18n/l10n';

import { useScroll } from '../../shared';
import { colorPalette, media, mediaBreakpoints, timings } from '../../../styles/GlobalStyle';
import HeaderByLicenses from '../../core/components/HeaderByLicenses';
import appConfig from 'config/app.config';
import { Licenses } from 'types/common';

type HeaderRawProps = {
  className?: string,
};

const HeaderElement = styled.header`
  position: relative;
  width: 100%;
  max-width: ${mediaBreakpoints.wide};
  background-color: ${colorPalette.dark.active};
  transition: transform ${timings.shadow};
  z-index: 1;

  ${media.greaterThan('desktop')`
    position: fixed;
    top: 0;
    transform: translateX(-50%);
    left: 50%;
`}

  &.header--form {
    max-width: none;
    z-index: 1;
    height: 60px;
    ${media.greaterThan('desktop')`
    &.no-disclaimer {
      height: 8px;
    }
  `}
    &:before {
      display: none;
    }
  }

  &.header--sticky {
    position: fixed;
    top: 0;
    transform: translateY(-100%);
    opacity: 0;
    transition: all 300ms;
    &.visible {
      transform: translateY(0%);
      opacity: 1;
    }
    &:before {
      display: block;
    }
    ${media.greaterThan('desktop')`
    display: none;
  `}
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    display: block;
    width: 100%;
    height: 60px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
    transition: opacity ${timings.shadow}, transform 0ms ${timings.shadow};
    user-select: none;
    opacity: 0;
  }

  ${media.greaterThan('desktop')`
    height: 80px;
  `}

  ${(p) =>
    p.scrolled &&
    `
  &:before {
    transition: opacity ${timings.shadow}, transform 0ms;
    transform: translateY(100%);
    opacity: 1;
  }
`}

  ${media.greaterThan('desktop')`

  ${(p) =>
    p.scrolled &&
    `
    transform: translate(-50%, -60px);
  `}
`}
`;

const StyledHeaderByLicenses = styled(HeaderByLicenses)`
  ${({ $showMobileHeader }) =>
    $showMobileHeader &&
    css`
      display: flex;
      justify-content: center;

      & > *:not(:first-child) {
        display: none;
      }

      ${media.greaterThan('desktop')`
      & > *:not(:first-child) {
        display: inherit;
      }
    
      justify-content: space-between;
    `}
    `}
`;

export const LandingHeader = ({ className }: HeaderRawProps) => {
  const { y } = useScroll();
  const scrolled = y > 0;

  const showMobileHeader = useMemo(
    () => getLang() === 'fr' && appConfig.licence === Licenses.FR,
    []
  );

  return (
    <>
      <HeaderElement
        scrolled={scrolled}
        className={`${className ? className : ''} header--form${
          getLang() !== 'fr' ? ' no-disclaimer' : ''
        }`}
      >
        <StyledHeaderByLicenses $showMobileHeader={showMobileHeader} />
      </HeaderElement>
    </>
  );
};
